import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { CustomDateAdapter } from '../../../shared/services/custom-date-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { environment } from '../../../../environments/environment';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { FooterActionComponent } from '../../../shared/components/footer-action/footer-action.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { LoteInventarioModalComponent, LoteInventarioModalData, LoteInventarioModalItem } from '../../../shared/components/lote-inventario-modal/lote-inventario-modal.component';
import { SerieInventarioModalComponent, SerieInventarioModalData, SerieInventarioModalItem } from '../../../shared/components/serie-inventario-modal/serie-inventario-modal.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MaskService } from '../../../shared/services/mask.service';
import { LookupService } from '../../../shared/services/apis/produto/produto-lookup.service';
import { InventarioOrquestradorService } from '../../../shared/services/apis/orquestrador-suprimentos/inventario-orquestrador.service';
import { InventarioConsultaOrquestradorService } from '../../../shared/services/apis/orquestrador-suprimentos/inventario-consulta-orquestrador.service';
import { InventarioService } from '../../../shared/services/apis/suprimentos/inventario.service';
import { UsuarioService } from '../../../shared/services/apis/usuario/usuario.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { CriarInventarioItemRequest } from '../../../shared/services/requests/suprimentos/criar-inventario-item.request';
import { CriarInventarioLocalizacaoRequest } from '../../../shared/services/requests/suprimentos/criar-inventario-localizacao.request';
import { CriarInventarioRequest } from '../../../shared/services/requests/suprimentos/criar-inventario.request';
import { LookupItemStruct } from '../../../shared/services/structs/pessoa/lookup-item.struct';
import { UsuarioListaStruct } from '../../../shared/services/structs/usuario/usuario-lista.struct';
import { InventarioDigitacaoStruct } from '../../../shared/services/structs/suprimentos/inventario-digitacao.struct';
import { ControleEstoqueListStruct } from '../../../shared/services/structs/produto/controle-estoque-list.struct';
import { DigitacaoLocal, DigitacaoProduto, LinhaGrid, ID_TIPO_ORIGEM_DIGITACAO_MANUAL, ID_TIPO_VALOR_BASE_PADRAO } from './inventario-digitacao.models';
import { InventarioDigitacaoMobileComponent } from './components/inventario-digitacao-mobile/inventario-digitacao-mobile.component';
import { AlertCardComponent } from '../../../shared/components/alert-card/alert-card.component';
import { StatusInventarioEnum } from '../../../shared/enums/suprimentos/status-inventario.enum';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';

@Component({
  selector: 'app-inventario-digitacao',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HeaderComponent,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatCheckboxModule,
    MatDatepickerModule,
    NgxCurrencyDirective,
    MatNativeDateModule,
    FooterActionComponent,
    InventarioDigitacaoMobileComponent,
    SelectPesquisavelComponent,
    MatRadioModule,
    AlertCardComponent,
    AbntPipe,
  ],
  templateUrl: './inventario-digitacao.component.html',
  styleUrl: './inventario-digitacao.component.css',
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
})
export class InventarioDigitacaoComponent implements OnInit {
  public moduloEnum = ModuloEnum.Suprimentos;
  public funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_InventarioEstoque;

  public idInventario = 0;
  public isEdicao = false;
  public isReadOnly = false;
  public idStatusInventario = 0;
  public mensagemProcessamento?: string;
  public _isLoading = false;
  public _StatusInventarioEnum = StatusInventarioEnum;
  public readonly hoje: Date = new Date();

  public formInventario: FormGroup;
  public listaLocalizacoes: LookupItemStruct[] = [];
  public listaUsuarios: UsuarioListaStruct[] = [];
  public itens: DigitacaoProduto[] = [];
  public linhasGrid: LinhaGrid[] = [];
  public displayedColumns = ['produto', 'sku', 'unidade', 'local', 'quantidade', 'acoes'];

  public isDirty = false;
  public isSalvandoRascunho = false;
  public isConcluindo = false;

  // Select de produto inline por linha
  public urlProduto = `${environment.urlApiProduto}Lookup/listProdutoSelect`;

  // Filtro de produtos da listagem
  public filtroProduto = '';
  public get linhasGridFiltradas(): LinhaGrid[] {
    const t = this.filtroProduto.trim().toLowerCase();
    if (!t) return this.linhasGrid;
    return this.linhasGrid.filter(l => !l.produto.idProduto
      || (l.produto.nome || '').toLowerCase().includes(t)
      || (l.produto.sku || '').toLowerCase().includes(t));
  }

  // Layout mobile (mesma rota): abaixo deste limite usa a experiência de digitação com câmera.
  public isMobile = false;
  private readonly MOBILE_BREAKPOINT = 768;

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth <= this.MOBILE_BREAKPOINT;
  }

  private _urlOrigem = '/suprimentos/inventario';
  private _produtosPreFiltrados: any[] | null = null;
  private _idLocalizacaoPreFiltro: number | null = null;

  // Regra de conflito: produtos que já constam em outro inventário aberto (o backend também valida)
  private _produtosBloqueados = new Set<number>();

  @ViewChild('descricaoInput') descricaoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('localizacoesSelect') localizacoesSelect?: MatSelect;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private inventarioService: InventarioService,
    private orquestradorService: InventarioOrquestradorService,
    private inventarioConsultaService: InventarioConsultaOrquestradorService,
    private lookupService: LookupService,
    private usuarioService: UsuarioService,
    private authService: AuthService,
    private alertService: AlertService,
    private maskService: MaskService
  ) { }

  // Máscara de quantidade com as casas decimais globais do usuário (token info).
  public quantidadeMask = { ...this.maskService.getDynamicDecimalMask(), allowNegative: false };

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= this.MOBILE_BREAKPOINT;

    const param = this.route.snapshot.paramMap.get('idInventario');
    this.idInventario = Number(param);
    this.isEdicao = !!param && !isNaN(this.idInventario) && this.idInventario > 0;

    this._initForm();
    this._carregarLocalizacoes();
    this._carregarUsuarios();
    this._carregarProdutosBloqueados();

    if (this.isEdicao) {
      this._carregarInventarioExistente();
    } else {
      this._aplicarEstadoFiltragem();
    }

    this.formInventario.get('idsLocalizacoes')!.valueChanges.subscribe((ids: number[]) => {
      if (this._isLoading) return;
      this._reconciliarLocais(ids ?? []);
    });
  }

  // ───────────────────────────────────────────────────────────────────────────
  // Inicialização
  // ───────────────────────────────────────────────────────────────────────────

  private _initForm(): void {
    const hoje = new Date();
    const usuarioLogado = this.authService.getUserInfos();
    this.formInventario = this.fb.group({
      descricao: ['Inventário / Balanço', [Validators.required, Validators.minLength(3)]],
      idsLocalizacoes: [[], Validators.required],
      idUsuarioResponsavel: [usuarioLogado.idUsuario || null, Validators.required],
      dataInventario: [hoje, Validators.required],
      motivo: [''],
      modoProcessamento: [0],
    });
  }

  private _carregarProdutosBloqueados(): void {
    this.inventarioService.getProdutosEmAberto(this.isEdicao ? this.idInventario : undefined).subscribe({
      next: res => {
        if (!res.isError) this._produtosBloqueados = new Set(res.idsProduto);
      },
      error: () => {
        // Sem bloqueio local; o backend valida na persistência
      },
    });
  }

  private _aplicarEstadoFiltragem(): void {
    const navState = window.history.state as { fromFiltro?: boolean; idLocalizacaoEstoque?: number | null; todosProdutos?: any[] };
    if (navState?.fromFiltro) {
      this._produtosPreFiltrados = navState.todosProdutos ?? null;
      this._idLocalizacaoPreFiltro = navState.idLocalizacaoEstoque ?? null;
      this._urlOrigem = '/suprimentos/inventario/filtrar-produtos';
    }
  }

  private _carregarLocalizacoes(): void {
    this.lookupService.getLocalizacaoEstoqueSelect().subscribe({
      next: res => {
        if (res.isError) { this.alertService.show('Erro', res.errorDescription, AlertType.error); return; }
        this.listaLocalizacoes = res.list ?? [];

        if (!this.isEdicao && this._produtosPreFiltrados) {
          const idsIniciais = this._idLocalizacaoPreFiltro
            ? [this._idLocalizacaoPreFiltro]
            : this._inferirLocalizacoesDosProdutos(this._produtosPreFiltrados);
          this.formInventario.get('idsLocalizacoes')!.setValue(idsIniciais, { emitEvent: false });
          this._popularItensDaFiltragem(idsIniciais);
        }

        if (!this.isEdicao && !this._produtosPreFiltrados) {
          setTimeout(() => this.localizacoesSelect?.focus(), 0);
        }
      },
      error: err => this.alertService.show('Erro', err.message || err, AlertType.error),
    });
  }

  private _carregarUsuarios(): void {
    this.usuarioService.getAll().subscribe({
      next: res => {
        if (!res.isError) this.listaUsuarios = (res.listaUsuario ?? []).filter(u => u.ativo);
      },
    });
  }

  private _carregarInventarioExistente(): void {
    // Leitura enriquecida (Suprimentos + dados de produto) via Orquestrador.
    this._isLoading = true;
    this.inventarioConsultaService.getDigitacao(this.idInventario).subscribe({
      next: res => {
        this._isLoading = false;
        if (res.isError) { this.alertService.show('Erro', res.errorDescription, AlertType.error); return; }
        this._popularDeInventarioExistente(res.digitacao);
      },
      error: err => { this._isLoading = false; this.alertService.show('Erro', err.message || err, AlertType.error); },
    });
  }

  private _popularDeInventarioExistente(digitacao: InventarioDigitacaoStruct): void {
    // Apenas o status Pendente (1) permanece editável.
    this.isReadOnly = digitacao.idStatusInventario !== 1;
    this.idStatusInventario = digitacao.idStatusInventario;
    this.mensagemProcessamento = digitacao.mensagemProcessamento;

    const idsLocalizacoes = (digitacao.localizacoes ?? []).map(l => l.idLocalizacaoEstoque);
    const dataInventario = digitacao.dataInventario
      ? new Date(digitacao.dataInventario)
      : (digitacao.datetimeInclusao ? new Date(digitacao.datetimeInclusao) : new Date());
    const modoProcessamento = digitacao.idTipoValorBaseInventario === 2 ? 1 : 0;

    this.formInventario.patchValue({
      descricao: digitacao.descricao ?? '',
      idsLocalizacoes,
      idUsuarioResponsavel: digitacao.idUsuarioResponsavel ?? null,
      motivo: digitacao.motivo ?? digitacao.observacao ?? '',
      dataInventario,
      modoProcessamento,
    }, { emitEvent: false });

    // Agregar itens (produto pode existir em múltiplas localizações)
    const mapaProdutos = new Map<number, DigitacaoProduto>();
    for (const loc of digitacao.localizacoes ?? []) {
      for (const item of loc.itens ?? []) {
        let produto = mapaProdutos.get(item.idProduto);
        if (!produto) {
          produto = {
            idProduto: item.idProduto,
            nome: item.nomeProduto,
            sku: item.skuProduto,
            unidade: item.unidadeMedida ?? 'UN',
            custoMedio: item.custoMedio,
            isControlaLotes: item.isControlaLotes,
            isControlaSeries: item.isControlaSeries,
            locais: [],
            produtoControl: new FormControl(item.idProduto),
            produtoPreload: [{ idProduto: item.idProduto, descricao: item.nomeProduto }],
          };
          mapaProdutos.set(item.idProduto, produto);
        }
        const temRastreabilidadeSalva = (item.lotes?.length ?? 0) > 0 || (item.series?.length ?? 0) > 0;
        produto.locais.push({
          idLocalizacaoEstoque: loc.idLocalizacaoEstoque,
          nomeLocalizacao: loc.nomeLocalizacao,
          saldoInicial: item.saldoSistema,
          quantidadeInventariada: item.saldoContado ?? null,
          idInventarioItem: item.idInventarioItem,
          lotes: item.lotes ? item.lotes.map(l => ({ ...l })) as LoteInventarioModalItem[] : undefined,
          series: item.series ? item.series.map(s => ({ ...s })) as SerieInventarioModalItem[] : undefined,
          // Itens controlados que já vieram com lote/série salvos contam como confirmados.
          confirmadoRastreabilidade: temRastreabilidadeSalva || !(item.isControlaLotes || item.isControlaSeries),
        });
      }
    }
    this.itens = Array.from(mapaProdutos.values());
    this._rebuildLinhasGrid();

    if (this.isReadOnly) this.formInventario.disable({ emitEvent: false });
  }

  private _inferirLocalizacoesDosProdutos(produtos: any[]): number[] {
    const ids = new Set<number>();
    for (const p of produtos) {
      for (const l of (p.locais ?? [])) ids.add(l.idLocalizacaoEstoque);
    }
    return Array.from(ids);
  }

  private _popularItensDaFiltragem(idsLoc: number[]): void {
    if (!this._produtosPreFiltrados) return;

    for (const p of this._produtosPreFiltrados) {
      const locais: DigitacaoLocal[] = [];
      for (const idLoc of idsLoc) {
        const localProduto = (p.locais ?? []).find((l: any) => l.idLocalizacaoEstoque === idLoc);
        const info = this.listaLocalizacoes.find(loc => loc.id === idLoc);
        locais.push({
          idLocalizacaoEstoque: idLoc,
          nomeLocalizacao: info?.descricao ?? `Localização ${idLoc}`,
          saldoInicial: localProduto?.saldoFisico ?? 0,
          quantidadeInventariada: null,
        });
      }
      this.itens.push({
        idProduto: p.idProduto,
        nome: p.descricao,
        sku: p.codigoSku,
        unidade: p.unidade ?? 'UN',
        custoMedio: p.custoMedio ?? 0,
        isControlaLotes: p.isControlaLotes ?? false,
        isControlaSeries: p.isControlaSeries ?? false,
        locais,
        produtoControl: new FormControl(p.idProduto),
        produtoPreload: [{ idProduto: p.idProduto, descricao: p.descricao }],
      });
    }

    this._rebuildLinhasGrid();
  }

  private _reconciliarLocais(idsLoc: number[]): void {
    const setIds = new Set(idsLoc);

    for (const item of this.itens) {
      item.locais = item.locais.filter(l => setIds.has(l.idLocalizacaoEstoque));

      for (const idLoc of idsLoc) {
        if (!item.locais.some(l => l.idLocalizacaoEstoque === idLoc)) {
          const info = this.listaLocalizacoes.find(loc => loc.id === idLoc);
          const localProduto = this._produtosPreFiltrados?.find(p => p.idProduto === item.idProduto)
            ?.locais?.find((l: any) => l.idLocalizacaoEstoque === idLoc);
          item.locais.push({
            idLocalizacaoEstoque: idLoc,
            nomeLocalizacao: info?.descricao ?? `Localização ${idLoc}`,
            saldoInicial: localProduto?.saldoFisico ?? 0,
            quantidadeInventariada: null,
          });
        }
      }
    }

    this.isDirty = true;
    this._rebuildLinhasGrid();
  }

  private _rebuildLinhasGrid(): void {
    const linhas: LinhaGrid[] = [];
    for (const item of this.itens) {
      if (item.locais.length === 0) continue;
      if (item.locais.length === 1) {
        linhas.push({ tipo: 'parent', idProduto: item.idProduto, produto: item, local: item.locais[0] });
      } else {
        linhas.push({ tipo: 'parent', idProduto: item.idProduto, produto: item });
        for (const loc of item.locais) {
          linhas.push({ tipo: 'sub', idProduto: item.idProduto, produto: item, local: loc });
        }
      }
    }
    this.linhasGrid = linhas;
  }

  // ───────────────────────────────────────────────────────────────────────────
  // Ações do grid
  // ───────────────────────────────────────────────────────────────────────────

  // Adiciona uma nova linha vazia; o produto é escolhido pelo select da própria linha.
  public async adicionarProduto(): Promise<void> {
    if (!this.validarCabecalhoObrigatorio()) {
      return;
    }

    const podeContinuar = await this.sugerirSalvarRascunhoNovoSeNecessario();
    if (!podeContinuar) return;

    const idsLoc: number[] = this.formInventario.get('idsLocalizacoes')!.value ?? [];
    this.itens.push({
      idProduto: 0,
      nome: '',
      sku: undefined,
      unidade: 'UN',
      custoMedio: 0,
      isControlaLotes: false,
      isControlaSeries: false,
      locais: this.montarLocais(idsLoc, []),
      produtoControl: new FormControl(null),
      produtoPreload: [],
    });
    this.isDirty = true;
    this._rebuildLinhasGrid();
  }

  // Troca/define o produto da linha pelo select. Reconfigura a linha (locais, lote/série).
  public onProdutoTrocadoInventario(item: DigitacaoProduto, sel: any): void {
    const id = sel?.idProduto;
    if (!id) return;

    if (this.itens.some(i => i !== item && i.idProduto === id)) {
      this.alertService.show('Atenção', 'Produto já foi adicionado.', AlertType.warning);
      item.produtoControl?.setValue(item.idProduto || null);
      return;
    }

    if (this._produtosBloqueados.has(id)) {
      this.alertService.show('Atenção', 'Produto já consta em outro inventário em andamento.', AlertType.warning);
      item.produtoControl?.setValue(item.idProduto || null);
      return;
    }

    // Campos descritivos já vêm completos no próprio objeto selecionado no autocomplete
    // (Lookup/listProdutoSelect) — sem precisar de mais uma requisição.
    item.idProduto = sel.idProduto;
    item.nome = sel.descricao;
    item.sku = sel.codigoSku ?? undefined;
    item.unidade = sel.unidade ?? 'UN';
    item.custoMedio = sel.custoMedio ?? 0;
    item.isControlaLotes = sel.isControlaLotes ?? false;
    item.isControlaSeries = sel.isControlaSeries ?? false;
    item.produtoPreload = [{ idProduto: sel.idProduto, descricao: sel.descricao }];
    this.isDirty = true;
    this._rebuildLinhasGrid();

    // Só o saldo por localização precisa de uma consulta (o autocomplete só traz agregado).
    const idsLoc: number[] = this.formInventario.get('idsLocalizacoes')!.value ?? [];
    this.lookupService.getProdutoSaldoLocal(id, idsLoc).subscribe({
      next: (resp) => {
        if (resp?.isError) {
          this.alertService.show('Erro', 'Não foi possível carregar o saldo do produto.', AlertType.error);
          return;
        }
        item.locais = this.montarLocais(idsLoc, (resp.list ?? []).map(l => ({
          idLocalizacaoEstoque: l.idLocalizacaoEstoque,
          saldoFisico: l.saldoFisico,
        })));
        this._rebuildLinhasGrid();
      },
      error: () => this.alertService.show('Erro', 'Não foi possível carregar o saldo do produto.', AlertType.error),
    });
  }

  // Monta os locais de um produto a partir das localizações selecionadas no cabeçalho.
  private montarLocais(idsLoc: number[], saldos: { idLocalizacaoEstoque: number; saldoFisico: number }[]): DigitacaoLocal[] {
    return idsLoc.map(idLoc => {
      const info = this.listaLocalizacoes.find(l => l.id === idLoc);
      const saldo = saldos.find(s => s.idLocalizacaoEstoque === idLoc)?.saldoFisico ?? 0;
      return {
        idLocalizacaoEstoque: idLoc,
        nomeLocalizacao: info?.descricao ?? `Localização ${idLoc}`,
        saldoInicial: saldo,
        quantidadeInventariada: null,
      };
    });
  }

  public temLinhaProdutoVazio(): boolean {
    return this.itens.some(i => !i.idProduto);
  }

  // Conta produto/local com lote/série que o usuário ainda não confirmou no modal.
  public contarRastreabilidadeNaoConfirmada(): number {
    let total = 0;
    for (const item of this.itens) {
      if (!item.isControlaLotes && !item.isControlaSeries) continue;
      for (const local of item.locais) {
        if (!local.confirmadoRastreabilidade) total++;
      }
    }
    return total;
  }

  // Inclui um produto (vindo da busca/leitura) nas localizações selecionadas no cabeçalho.
  // Retorna false se o produto já estava na lista. Usado por desktop e mobile.
  public incluirProdutoDaBusca(p: ControleEstoqueListStruct): boolean {
    const idsLoc: number[] = this.formInventario.get('idsLocalizacoes')!.value ?? [];
    if (this.itens.some(i => i.idProduto === p.idProduto)) {
      return false;
    }

    if (this._produtosBloqueados.has(p.idProduto)) {
      this.alertService.show('Atenção', `"${p.descricao}" já consta em outro inventário em andamento.`, AlertType.warning);
      return false;
    }

    const locais: DigitacaoLocal[] = [];
    for (const idLoc of idsLoc) {
      const localProduto = (p.locais ?? []).find((l: any) => l.idLocalizacaoEstoque === idLoc);
      const info = this.listaLocalizacoes.find(loc => loc.id === idLoc);
      locais.push({
        idLocalizacaoEstoque: idLoc,
        nomeLocalizacao: info?.descricao ?? `Localização ${idLoc}`,
        saldoInicial: localProduto?.saldoFisico ?? 0,
        quantidadeInventariada: null,
      });
    }

    this.itens.push({
      idProduto: p.idProduto,
      nome: p.descricao,
      sku: p.codigoSku,
      unidade: p.unidade ?? 'UN',
      custoMedio: p.custoMedio ?? 0,
      isControlaLotes: p.isControlaLotes ?? false,
      isControlaSeries: p.isControlaSeries ?? false,
      locais,
      produtoControl: new FormControl(p.idProduto),
      produtoPreload: [{ idProduto: p.idProduto, descricao: p.descricao }],
    });
    this.isDirty = true;
    this._rebuildLinhasGrid();
    return true;
  }

  // Localiza um produto já adicionado (pelo mobile, após pesquisa/leitura).
  public encontrarProduto(idProduto: number): DigitacaoProduto | undefined {
    return this.itens.find(i => i.idProduto === idProduto);
  }

  // Registra a contagem de um local (mobile). Mantém a mesma semântica do onQuantidadeChange.
  public registrarContagem(idProduto: number, idLocalizacaoEstoque: number, quantidade: number | null): void {
    const local = this.encontrarProduto(idProduto)?.locais.find(l => l.idLocalizacaoEstoque === idLocalizacaoEstoque);
    if (!local) return;
    local.quantidadeInventariada = quantidade;
    this.isDirty = true;
  }

  // Aplica lotes/séries vindos do painel mobile, recalculando a quantidade do local.
  public aplicarLotesNoLocal(idProduto: number, idLocalizacaoEstoque: number, lotes: LoteInventarioModalItem[]): void {
    const local = this.encontrarProduto(idProduto)?.locais.find(l => l.idLocalizacaoEstoque === idLocalizacaoEstoque);
    if (!local) return;
    local.lotes = lotes;
    local.quantidadeInventariada = lotes.reduce((s, l) => s + (l.saldoContado || 0), 0);
    local.confirmadoRastreabilidade = true;
    this.isDirty = true;
  }

  public aplicarSeriesNoLocal(idProduto: number, idLocalizacaoEstoque: number, series: SerieInventarioModalItem[]): void {
    const local = this.encontrarProduto(idProduto)?.locais.find(l => l.idLocalizacaoEstoque === idLocalizacaoEstoque);
    if (!local) return;
    local.series = series;
    local.quantidadeInventariada = series.reduce((s, x) => s + (x.saldoContado || 0), 0);
    local.confirmadoRastreabilidade = true;
    this.isDirty = true;
  }

  // Wrapper público para o mobile reconstruir a lista após mudanças.
  public rebuildGrid(): void {
    this._rebuildLinhasGrid();
  }

  public removerProduto(idProduto: number): void {
    this.itens = this.itens.filter(i => i.idProduto !== idProduto);
    this.isDirty = true;
    this._rebuildLinhasGrid();
  }

  public abrirLoteModalOffline(produto: DigitacaoProduto, local: DigitacaoLocal): void {
    const data: LoteInventarioModalData = {
      idInventarioItem: local.idInventarioItem ?? 0,
      idProduto: produto.idProduto,
      idLocalizacaoEstoque: local.idLocalizacaoEstoque,
      nomeProduto: produto.nome,
      skuProduto: produto.sku,
      saldoSistema: local.saldoInicial,
      lotes: (local.lotes ?? []).map(l => ({ ...l })),
      isReadOnly: this.isReadOnly,
    };
    this.dialog.open(LoteInventarioModalComponent, { width: '1040px', maxWidth: '95vw', maxHeight: '90vh', data })
      .afterClosed().subscribe(result => {
        if (!result?.confirmed) return;
        local.lotes = result.lotes;
        local.quantidadeInventariada = (result.lotes as LoteInventarioModalItem[]).reduce((s, l) => s + (l.saldoContado || 0), 0);
        local.confirmadoRastreabilidade = true;
        this.isDirty = true;
      });
  }

  public abrirSerieModalOffline(produto: DigitacaoProduto, local: DigitacaoLocal): void {
    const data: SerieInventarioModalData = {
      idInventarioItem: local.idInventarioItem ?? 0,
      idProduto: produto.idProduto,
      idLocalizacaoEstoque: local.idLocalizacaoEstoque,
      nomeProduto: produto.nome,
      skuProduto: produto.sku,
      saldoSistema: local.saldoInicial,
      series: (local.series ?? []).map(s => ({ ...s })),
      isReadOnly: this.isReadOnly,
    };
    this.dialog.open(SerieInventarioModalComponent, { width: '640px', maxWidth: '95vw', maxHeight: '90vh', data })
      .afterClosed().subscribe(result => {
        if (!result?.confirmed) return;
        local.series = result.series;
        local.quantidadeInventariada = (result.series as SerieInventarioModalItem[]).reduce((s, x) => s + (x.saldoContado || 0), 0);
        local.confirmadoRastreabilidade = true;
        this.isDirty = true;
      });
  }

  public onQuantidadeChange(local: DigitacaoLocal, value: number | null): void {
    local.quantidadeInventariada = value ?? null;
    this.isDirty = true;
  }

  public somaQuantidades(produto: DigitacaoProduto): number {
    return produto.locais.reduce((s, l) => s + (l.quantidadeInventariada ?? 0), 0);
  }

  public ajuste(local: DigitacaoLocal): number | null {
    if (local.quantidadeInventariada == null) return null;
    return local.quantidadeInventariada - local.saldoInicial;
  }

  public getAjusteClass(value: number | null | undefined): string {
    if (value == null) return '';
    if (value > 0) return 'ajuste-positivo';
    if (value < 0) return 'ajuste-negativo';
    return 'ajuste-neutro';
  }

  // ───────────────────────────────────────────────────────────────────────────
  // Salvar / Concluir
  // ───────────────────────────────────────────────────────────────────────────

  public validarCabecalhoObrigatorio(): boolean {
    const descricaoCtrl = this.formInventario.get('descricao')!;
    const idsLocalizacoesCtrl = this.formInventario.get('idsLocalizacoes')!;
    const usuarioCtrl = this.formInventario.get('idUsuarioResponsavel')!;
    const dataCtrl = this.formInventario.get('dataInventario')!;

    if (!descricaoCtrl.value || descricaoCtrl.invalid) {
      descricaoCtrl.markAsTouched();
      this.alertService.show('Atenção', 'Informe a descrição do inventário.', AlertType.warning);
      return false;
    }

    const idsLocalizacoes: number[] = idsLocalizacoesCtrl.value ?? [];
    if (!idsLocalizacoes.length) {
      idsLocalizacoesCtrl.markAsTouched();
      this.alertService.show('Atenção', 'Selecione ao menos uma localização de estoque.', AlertType.warning);
      return false;
    }

    if (!usuarioCtrl.value) {
      usuarioCtrl.markAsTouched();
      this.alertService.show('Atenção', 'Selecione o responsável pelo inventário.', AlertType.warning);
      return false;
    }

    if (!dataCtrl.value) {
      dataCtrl.markAsTouched();
      this.alertService.show('Atenção', 'Informe a data do inventário.', AlertType.warning);
      return false;
    }

    return true;
  }

  public async sugerirSalvarRascunhoNovoSeNecessario(): Promise<boolean> {
    if (this.isEdicao || this.idInventario > 0 || this.itens.length === 0 || this.isSalvandoRascunho || this.isConcluindo) {
      return true;
    }

    if (!this.validarCabecalhoObrigatorio()) {
      return false;
    }

    const result = await firstValueFrom(this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Salvar inventário?',
        description: 'Você já adicionou produtos, mas o inventário ainda não foi salvo. Deseja salvar o rascunho agora?',
        buttonConfirm: 'Salvar',
        buttonClose: 'Agora não',
      },
    }).afterClosed());

    if (!result?.confirm) {
      return true;
    }

    const salvou = await this._salvarRascunhoBase(false);
    if (salvou) {
      this.alertService.show('Sucesso', 'Inventário salvo.', AlertType.success);
    }
    return salvou;
  }

  public async salvarRascunhoAutomatico(): Promise<boolean> {
    if (!this.validarCabecalhoObrigatorio()) return false;
    if (this.itens.length === 0) {
      this.alertService.show('Atenção', 'Adicione ao menos um produto ao inventário.', AlertType.warning);
      return false;
    }

    return this._salvarRascunhoBase(false);
  }

  public async salvarRascunho(): Promise<void> {
    await this._salvarRascunhoBase(true);
  }

  private async _salvarRascunhoBase(exibirSucesso: boolean): Promise<boolean> {
    if (!this.validarCabecalhoObrigatorio()) {
      this.formInventario.markAllAsTouched();
      return false;
    }

    if (this.itens.length === 0) {
      this.alertService.show('Atenção', 'Adicione ao menos um produto ao inventário.', AlertType.warning);
      return false;
    }

    if (this.temLinhaProdutoVazio()) {
      this.alertService.show('Atenção', 'Selecione o produto em todas as linhas adicionadas.', AlertType.warning);
      return false;
    }

    this.isSalvandoRascunho = true;
    try {
      await this._persistir();
      if (exibirSucesso) {
        this.alertService.show('Sucesso', 'Inventário salvo.', AlertType.success);
      }
      return true;
    } catch (err: any) {
      this.alertService.show('Erro', err.message || String(err), AlertType.error);
      return false;
    } finally {
      this.isSalvandoRascunho = false;
    }
  }

  public async concluirInventario(): Promise<void> {
    if (!this.validarCabecalhoObrigatorio()) { this.formInventario.markAllAsTouched(); return; }
    if (this.itens.length === 0) {
      this.alertService.show('Atenção', 'Adicione ao menos um produto ao inventário.', AlertType.warning);
      return;
    }
    if (this.temLinhaProdutoVazio()) {
      this.alertService.show('Atenção', 'Selecione o produto em todas as linhas adicionadas.', AlertType.warning);
      return;
    }

    const naoConfirmados = this.contarRastreabilidadeNaoConfirmada();
    if (naoConfirmados > 0) {
      const confirmou = await firstValueFrom(this.dialog.open(ConfirmModalComponent, {
        width: '480px',
        data: {
          title: 'Concluir sem confirmar lotes/séries?',
          description:
            `Existe(m) ${naoConfirmados} produto(s)/local(is) com controle de lote/série que você ainda não abriu e confirmou. ` +
            `Ao concluir sem confirmar a contagem dentro do modal de lote/série, a quantidade contada desses itens será considerada ZERADA. ` +
            `Deseja concluir o inventário mesmo assim?`,
          buttonConfirm: 'Concluir mesmo assim',
          buttonClose: 'Revisar',
        },
      }).afterClosed());

      if (!confirmou?.confirm) return;
    }

    this.isConcluindo = true;
    try {
      const idInventario = await this._persistir();
      await firstValueFrom(this.orquestradorService.processar(idInventario));
      this.alertService.show('Sucesso', 'Inventário concluído com sucesso!', AlertType.success);
      this.router.navigate(['/suprimentos/inventario']);
    } catch (err: any) {
      this.alertService.show('Erro', err.message || String(err), AlertType.error);
    } finally {
      this.isConcluindo = false;
    }
  }

  private async _persistir(): Promise<number> {
    if (this.isEdicao && this.idInventario > 0) {
      return this._persistirExistente();
    }
    return this._persistirNovo();
  }

  private _montarRequest(): CriarInventarioRequest {
    const { descricao, idsLocalizacoes, idUsuarioResponsavel, dataInventario, motivo, modoProcessamento } = this.formInventario.value;

    const localizacoesRequest: CriarInventarioLocalizacaoRequest[] = (idsLocalizacoes as number[]).map(idLoc => {
      const locInfo = this.listaLocalizacoes.find(l => l.id === idLoc);
      const produtos: CriarInventarioItemRequest[] = this.itens
        .filter(item => item.idProduto && item.locais.some(l => l.idLocalizacaoEstoque === idLoc))
        .map(item => {
          const loc = item.locais.find(l => l.idLocalizacaoEstoque === idLoc)!;
          return {
            idProduto: item.idProduto,
            saldoAtual: loc.saldoInicial,
          };
        });
      return {
        idLocalizacaoEstoque: idLoc,
        nomeLocalizacao: locInfo?.descricao ?? `Localização ${idLoc}`,
        produtos,
      };
    }).filter(l => l.produtos.length > 0);

    const dataIso = dataInventario instanceof Date
      ? dataInventario.toISOString()
      : (dataInventario ? new Date(dataInventario).toISOString() : new Date().toISOString());

    return {
      descricao,
      motivo: motivo || undefined,
      idUsuarioResponsavel,
      dataInventario: dataIso,
      idTipoOrigemInventario: ID_TIPO_ORIGEM_DIGITACAO_MANUAL,
      idTipoValorBaseInventario: modoProcessamento === 1 ? 2 : 1,
      localizacoes: localizacoesRequest,
    };
  }

  private async _persistirNovo(): Promise<number> {
    const request = this._montarRequest();

    const res = await firstValueFrom(this.inventarioService.criar(request));
    if (res.isError) throw new Error(res.errorDescription);

    // Busca a digitação para descobrir os idInventarioItem gerados pelo backend
    const getRes = await firstValueFrom(this.inventarioService.getDigitacao(res.idInventario));
    const digitacao = getRes.digitacao;

    // Atualiza referências locais e persiste contagens
    if (digitacao) {
      this._atualizarReferenciasLocais(digitacao);
      await this._salvarContagensItens(res.idInventario);
    }

    // A partir daqui passa a comportar-se como edição (caso o usuário continue editando)
    this.idInventario = res.idInventario;
    this.isEdicao = true;
    this.isDirty = false;
    this.router.navigate(['/suprimentos/inventario', res.idInventario], { replaceUrl: true, state: { skipReload: true } });
    return res.idInventario;
  }

  private async _persistirExistente(): Promise<number> {
    const request = this._montarRequest();

    const res = await firstValueFrom(this.inventarioService.atualizar(this.idInventario, request));
    if (res.isError) throw new Error(res.errorDescription);

    // O PUT só atualiza o cabeçalho: produtos adicionados na edição precisam ser
    // persistidos via adicionar-itens antes de salvar as contagens
    const itensNovos = this._montarRequestItensNovos(request);
    if (itensNovos.length > 0) {
      const addRes = await firstValueFrom(this.inventarioService.adicionarItens(this.idInventario, itensNovos));
      if (addRes.isError) throw new Error(addRes.errorDescription);
    }

    const getRes = await firstValueFrom(this.inventarioService.getDigitacao(this.idInventario));
    if (getRes?.digitacao) {
      this._atualizarReferenciasLocais(getRes.digitacao);
    }

    await this._salvarContagensItens(this.idInventario);
    this.isDirty = false;
    return this.idInventario;
  }

  // Produto/local ainda sem idInventarioItem = incluído nesta edição e não persistido
  private _montarRequestItensNovos(request: CriarInventarioRequest): CriarInventarioLocalizacaoRequest[] {
    return request.localizacoes
      .map(loc => ({
        ...loc,
        produtos: loc.produtos.filter(p => {
          const item = this.itens.find(i => i.idProduto === p.idProduto);
          const local = item?.locais.find(x => x.idLocalizacaoEstoque === loc.idLocalizacaoEstoque);
          return !!local && !local.idInventarioItem;
        }),
      }))
      .filter(loc => loc.produtos.length > 0);
  }

  private _atualizarReferenciasLocais(digitacao: InventarioDigitacaoStruct): void {
    for (const item of this.itens) {
      for (const loc of item.locais) {
        const locDigitacao = digitacao.localizacoes.find(l => l.idLocalizacaoEstoque === loc.idLocalizacaoEstoque);
        const itemDigitacao = locDigitacao?.itens.find(i => i.idProduto === item.idProduto);
        if (itemDigitacao) loc.idInventarioItem = itemDigitacao.idInventarioItem;
      }
    }
  }

  private async _salvarContagensItens(idInventario: number): Promise<void> {
    const salvarPromises: Promise<any>[] = [];

    for (const item of this.itens) {
      for (const loc of item.locais) {
        if (!loc.idInventarioItem) continue; // item ainda não persistido — backend gap

        if (item.isControlaLotes && loc.lotes && loc.lotes.length > 0) {
          // Só o id trafega — código/datas vivem no cadastro do Produto (resolvidos no modal via obter-ou-criar).
          const lotes = loc.lotes
            .filter(l => !!l.idLote)
            .map(l => ({ idLote: l.idLote!, saldoSistema: l.saldoSistema, saldoContado: l.saldoContado }));
          salvarPromises.push(
            firstValueFrom(this.inventarioService.salvarLotes(idInventario, loc.idInventarioItem, { lotes }))
          );
        } else if (item.isControlaSeries && loc.series && loc.series.length > 0) {
          const series = loc.series
            .filter(s => !!s.idSerie)
            .map(s => ({ idSerie: s.idSerie!, saldoSistema: s.saldoSistema, saldoContado: s.saldoContado }));
          salvarPromises.push(
            firstValueFrom(this.inventarioService.salvarSeries(idInventario, loc.idInventarioItem, { series }))
          );
        } else if (loc.quantidadeInventariada != null) {
          salvarPromises.push(
            firstValueFrom(this.inventarioService.salvarContagem(idInventario, loc.idInventarioItem, {
              saldoContado: loc.quantidadeInventariada,
            }))
          );
        }
      }
    }

    if (salvarPromises.length > 0) await Promise.all(salvarPromises);
  }

  // ───────────────────────────────────────────────────────────────────────────
  // Cancelar / voltar inteligente
  // ───────────────────────────────────────────────────────────────────────────

  public cancelar(): void {
    this.voltarComConfirmacao();
  }

  public voltar(): void {
    this.voltarComConfirmacao();
  }

  public voltarComConfirmacao(): void {
    if (!this.isDirty) {
      this.router.navigateByUrl(this._urlOrigem);
      return;
    }
    this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Descartar alterações?',
        description: 'Há alterações não salvas no inventário. Deseja sair mesmo assim?',
        buttonConfirm: 'Descartar',
        buttonClose: 'Voltar',
      },
    }).afterClosed().subscribe(result => {
      if (result?.confirm) this.router.navigateByUrl(this._urlOrigem);
    });
  }

  // ───────────────────────────────────────────────────────────────────────────
  // Data do inventário (digitação inline DD/MM/AAAA, sem futuro)
  // ───────────────────────────────────────────────────────────────────────────

  public onDateInput(event: Event): void {
    MaskService.onDateInput(event);
  }

  public onDateKeydown(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
    const isAtalho = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
    if (teclasPermitidas.includes(event.key) || isAtalho) return;
    if (!/^\d$/.test(event.key)) event.preventDefault();
  }

  public onDataInventarioBlur(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    const data = this.lerDataInput(input);
    const control = this.formInventario.get('dataInventario');
    if (data && data > this.hojeNormalizado()) {
      input.value = '';
      control?.setValue(null);
      control?.markAsDirty();
      this.alertService.show('Atenção', 'A data do inventário não pode ser maior que a data atual.', AlertType.warning);
      return;
    }
    control?.setValue(data);
    control?.markAsDirty();
  }

  private lerDataInput(input: HTMLInputElement): Date | null {
    const valor = (input?.value || '').trim();
    if (!valor) return null;
    const apenasNumeros = valor.replace(/\D/g, '').substring(0, 8);
    if (apenasNumeros.length !== 8) {
      input.value = '';
      this.alertService.show('Atenção', 'Informe uma data válida no formato DD/MM/AAAA.', AlertType.warning);
      return null;
    }
    const formatado = `${apenasNumeros.substring(0, 2)}/${apenasNumeros.substring(2, 4)}/${apenasNumeros.substring(4, 8)}`;
    input.value = formatado;
    const data = this.parseDataBr(formatado);
    if (!data) {
      input.value = '';
      this.alertService.show('Atenção', 'Informe uma data válida no formato DD/MM/AAAA.', AlertType.warning);
    }
    return data;
  }

  private parseDataBr(valor: string): Date | null {
    const partes = valor.split('/');
    if (partes.length !== 3) return null;
    const dia = Number(partes[0]);
    const mes = Number(partes[1]);
    const ano = Number(partes[2]);
    if (!Number.isInteger(dia) || !Number.isInteger(mes) || !Number.isInteger(ano)) return null;
    if (ano < 1000 || ano > 9999 || mes < 1 || mes > 12 || dia < 1 || dia > 31) return null;
    const data = new Date(ano, mes - 1, dia);
    data.setHours(0, 0, 0, 0);
    if (data.getFullYear() !== ano || data.getMonth() !== mes - 1 || data.getDate() !== dia) return null;
    return data;
  }

  private hojeNormalizado(): Date {
    const h = new Date();
    h.setHours(0, 0, 0, 0);
    return h;
  }
}
